export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),

  processFormValues() {
    const {
      measurementSystem,
      weightKg,
      weightLbs,
      age,
      heightFt,
      heightIn,
      heightCm,
      gender,
      firstName,
      goal,
      email,
    } = this.formValues

    let capitalizedName = firstName
    if (firstName) {
      capitalizedName = firstName.replace(/^\w/, (c) => c.toUpperCase())
    }

    const values = { firstName: capitalizedName, measurementSystem, age, gender, goal, email }

    // set goal weight to current weight if user doesn't want to lose weight
    const targetWeightKg =
      goal === "Develop healthy habits" ? weightKg : this.formValues.targetWeightKg
    const targetWeightLbs =
      goal === "Develop healthy habits" ? weightLbs : this.formValues.targetWeightLbs

    if (measurementSystem === "metric") {
      return { ...values, weightKg, heightCm, targetWeightKg }
    } else {
      return { ...values, weightLbs, heightIn, heightFt, targetWeightLbs }
    }
  },
})
